
import { AppBar, Box, Button, Grid, Typography, getContrastRatio } from "@mui/material"
import { useState } from "react"
import { customTheme as theme } from "../../theme/customTheme";
import ErrorHeader from "./ErrorHeader";
import errorImage from '../../assets/error.png';
import notFoundImage from '../../assets/404.svg';
import UnauthLayout from '../unauthv2/components/UnauthLayout'
import CustomButton from "../../components/CustomButton";
import Footer from "../unauthv2/components/Footer";
import Header from "../unauthv2/components/Header";
import luciLogo from '../../assets/luciLogo2.png'
import { generateLighterContrastColor } from "../../utils/commonServices";
import ErrorPageImage from "./assets/ErrorPageImage";

const ErrorPage = (props) => {

  const { componentStack, error } = props;
  const [displayError, updateDisplay] = useState(false)

  const primary = localStorage.getItem('primary')
  const secondary = localStorage.getItem('secondary')

  console.log('Lucihub Error Page')


  return (
    <>
      <Box sx={{width:'100%', position: "absolute", height: "100%", minWidth: "100vw", backgroundImage: primary === null && secondary === null ?'linear-gradient(110deg, #F7F7F730,  #E6E6E650, #F7F7F730 , #E6E6E650, #E6E6E670,#00CEFF20 , #00CEFF50 80%,  #00D74460 , #00D74460 )' : `linear-gradient(110deg, #F7F7F730,  #E6E6E650, #F7F7F730 , #E6E6E650, #E6E6E670,${secondary}20 , ${secondary}50 80%,  ${primary}60 , ${primary}60 )`}}>    
        <ErrorHeader />
        <Box
          sx={{
            overflowY: "scroll",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarColor: "#FFFFFF00",
            height: "calc(100% - 130px)",
            marginTop: { xs: "80px", lg: "80px" },
            px: { xs: '1vw', sm: "3vw", md: "6vw", lg:'6vw',xl:'6vw' },
            display:'flex',
            width:'100%',
            maxWidth:'1920px',
            margin:'auto'
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6 } lg={6} xl={6}  sx={{display:'flex', alignItems:'center', justifyContent:{xs:'center',md:'flex-start'}, }}>
                <Box pl={{sm:10}} pb={4}>
                    <Box  flexDirection='column'>
                        <Box sx={{marginY:{xs:'15px',md:'20px',lg:'25px',xl:'38px'}}}>
                            <Typography
                            variant="h4"
                            color="primary"
                            style={{
                                fontWeight: 600,
                                color:'#08231B'
                            }}
                            sx={{fontSize:{xs:'30px',sm:'40px',md:'40px',lg:'50px',xl:'80px'}, fontFamily:'Rubik'}}
                            >Oh Shoot.</Typography>
                        </Box>
                        <Box item xs={11} sm={8} md={7} gap={0.8} sx={{display:'flex', flexDirection:'column',}}>
                        <Typography sx={{color:'#707070', fontSize:{xs:'12px',md:'14px',lg:'16px',xl:'20px'}, fontFamily:'Helvetica'}}> Something went wrong! Please try to signin again</Typography>
                    </Box>

                <Box width='100%' sx={{mt: 3, display: 'flex', flexDirection: {xs: 'column-reverse', sm: 'row'}, justifyContent: { xs: 'flex-start', sm: 'flex-start'}, alignItems: {xs: 'center', sm: 'flex-start'} }} >
                    <CustomButton 
                    variant="contained" 
                    btnText="Sign out" 
                    // color='button'
                    style={{borderRadius: '5px', border:"none",  textTransform:'none'}}  
                    onClick={() => {window.localStorage.clear(); window.location.reload() }}
                    sx={{fontSize:{xs:'10px',sm:'10px',md:'11px',lg:'12px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"}, width:{xs:'100px',lg:'120px',xl:'160px'}, fontFamily:'Rubik', backgroundColor:'#08231B !important', 
                    color:  primary === null ? '#00d744' :  getContrastRatio('#08231B', primary) > 4.5 ? `${primary}` : generateLighterContrastColor(primary), 
                     }}
                        />      
                    </Box>           
                </Box>
            </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}  className='flex j-center a-center'>
                <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', }}  pl={{xs:2,sm:4,md:8,lg: 10,xl:12}}>
                    <Box sx={{height:{xs:180,sm:200,md:220,lg:'240px',xl:300}, marginBottom:{xs:'15px', sm:'15px',md:'20px',lg:'22.66px',xl:'34px'}}}>
                        {/* <img src={notFoundImage} alt="notFoundImage" height='100%' style={{objectFit:'cover', borderRadius:'10px'}} /> */}
                        <ErrorPageImage sx={{height: '100%', width: '100%', maxWidth: '350px'}} />
                    </Box>
                </Box>
            </Grid>
          </Grid>
        </Box>
     
        <Footer />
      </Box>
    </>
  );
}

export default ErrorPage;
